export default __webpack_public_path__ + "static/media/Armband of the Savage Slaughter.b53a48e4.jpg";